module.exports = __webpack_public_path__ + "static/media/Monopoly_F_HC.225bea97.png";